import React, { useEffect } from "react";
import SectionToggle from "../../../../components/sectionToggle/sectionToggle";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "./redux/membershipLengthSagas";
import LoadingAnimation from "../../../../components/loadingAnimation/loadingAnimation";
import ToggleableButton from "../../../../components/toggleableButton/toggleableButton";
import { DataPoints } from "./smartComponents/DataPoints";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import "./membershipLength.scss";
import PieChart from "../../../../components/pieChart/pieChart";
import TableWithCustomSearch from "../../../../components/coreUiTableWithCustomSearchAndDateConversion/TableWithCustomSearch";

export const MembershipLengthModule = ({ params }) => {
  const dispatch = useDispatch();

  const {
    isLoading,
    updatesLoading,
    formerMembershipsOnly,
    table: { table_data, table_headers = [], table_data_types, pie_chart, data_points }
  } = useSelector((state) => state.membershipLength);

  useEffect(() => {
    dispatch(actionCreators.fetchCurrentUser(params));
  }, []);

  const content = () => {
    return (
      <div>
        <div id="override-edit-selection-bar" className="edit-selections-bar">
          <div className="top-filter">
            <div>
              <div>
                <p>Former Memberships Only</p>
                <ToggleableButton
                  isActive={formerMembershipsOnly}
                  onClick={(isActive) => dispatch(actionCreators.handleToggle(isActive))}
                  title="membership-length-former-memberships-only"
                  isRadio
                />
              </div>
            </div>
            <ReactDatePicker
              calendarEndDate={params.calendarEndDate}
              disabled
              startDate={params.calendarEndDate}
            />
          </div>
        </div>

        {updatesLoading ? (
          <LoadingAnimation text="Updating data..." />
        ) : (
          <>
            <div style={{ display: "flex", alignItems: "center" }}>
              <DataPoints dataPoints={data_points} />
              <div className="pie-chart">
                <PieChart
                  width={810}
                  height={300}
                  data={pie_chart}
                  addOtherLabel={false}
                  showLegend
                  isLegendTooltip
                  legendPosition="right"
                  customTooltip
                  showRawLabels
                  legendTooltipPosition="left"
                />
              </div>
            </div>
            <div>
              <TableWithCustomSearch
                data={table_data}
                colHeaders={table_headers}
                columns={table_data_types}
                rawDataLink={data_points?.[0].url}
                fileName="membership-length"
                dateConversion={false}
                customFn={(header, formattedValue) => {
                  if (header === "Membership") {
                    return (
                      <div>
                        {formattedValue.length > 32
                          ? formattedValue.substring(0, 32) + "..."
                          : formattedValue}
                      </div>
                    );
                  }
                  return formattedValue;
                }}
              />
            </div>
          </>
        )}
      </div>
    );
  };
  return (
    <div id="membershipLength">
      <SectionToggle
        title="Membership Length"
        isLoading={isLoading}
        content={content()}
        paddingBottom={0}
        autoHeight
      />
    </div>
  );
};
